<script>
import { mapGetters } from "vuex";
import FButtonSection from "@/components/FButtonSection";

export default {
  name: "FPageSales",
  components: { FButtonSection },

  computed: {
    ...mapGetters(["companySelected"]),
  },
};
</script>

<template>
  <section>
    <FButtonSection
      v-if="[1, 3].includes(companySelected.tipoEmpresa)"
      to="/vendas/combustiveis?as=day"
      icon="local_gas_station"
      title="Combustíveis (Dia)"
      descr="Vendas de Combustíveis"
    />
    <FButtonSection
      v-if="[1, 3].includes(companySelected.tipoEmpresa)"
      to="/vendas/combustiveis?as=month"
      icon="local_gas_station"
      title="Combustíveis (Mês)"
      descr="Vendas de Combustíveis"
    />
    <FButtonSection
      v-if="[2, 3].includes(companySelected.tipoEmpresa)"
      to="/vendas/produtos?as=day"
      icon="store"
      title="Produtos (Dia)"
      descr="Vendas de Produtos"
    />
    <FButtonSection
      v-if="[2, 3].includes(companySelected.tipoEmpresa)"
      to="/vendas/produtos?as=month"
      icon="store"
      title="Produtos (Mês)"
      descr="Vendas de Produtos"
    />
  </section>
</template>
